import { render, staticRenderFns } from "./InstrumentsFuture.vue?vue&type=template&id=896c6d3a&scoped=true"
import script from "./InstrumentsFuture.vue?vue&type=script&lang=js"
export * from "./InstrumentsFuture.vue?vue&type=script&lang=js"
import style0 from "./InstrumentsFuture.vue?vue&type=style&index=0&id=896c6d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896c6d3a",
  null
  
)

export default component.exports